export enum ChainTypeEnum {
  Objects = 'OBJECTS',
  Services = 'SERVICES',
  Files = 'FILES',
  OrgObjects = 'ORG-OBJECTS',
  OrgServices = 'ORG-SERVICES',
  OrgFiles = 'ORG-FILES',
}
export enum ReportTypeEnum {
  Seller = 'Seller',
  Buyer = 'Buyer',
}

export enum FileTypeEnum {
  PDF = 'PDF',
  CSV = 'CSV',
}

export enum AssetStatusEnum {
  CREATED = 'CREATED',
  PHOTO_ADDED_STARTED = 'PHOTO_ADDED_STARTED',
  PHOTO_ADDED_FAILED = 'PHOTO_ADDED_FAILED',
  PHOTO_ADDED = 'PHOTO_ADDED',
  DOCUMENT_ADDED_STARTED = 'DOCUMENT_ADDED_STARTED',
  DOCUMENT_ADDED_FAILED = 'DOCUMENT_ADDED_FAILED',
  DOCUMENT_ADDED = 'DOCUMENT_ADDED',
  OFFICIAL_VERIFYING_STARTED = 'OFFICIAL_VERIFYING_STARTED',
  OFFICIAL_VERIFYING_FAILED = 'OFFICIAL_VERIFYING_FAILED',
  OFFICIAL_VERIFIED = 'OFFICIAL_VERIFIED',
  QR_BINDING_STARTED = 'QR_BINDING_STARTED',
  QR_BINDING_FAILED = 'QR_BINDING_FAILED',
  QR_BOUND = 'QR_BOUND',
  RFID_BINDING_STARTED = 'RFID_BINDING_STARTED',
  RFID_BINDING_FAILED = 'RFID_BINDING_FAILED',
  RFID_BOUND = 'RFID_BOUND',
  PRIVACY_STARTED = 'PRIVACY_STARTED',
  PRIVACY_FAILED = 'PRIVACY_FAILED',
  PRIVACY_DONE = 'PRIVACY_DONE',
  WITNESS_VERIFYING_STARTED = 'WITNESS_VERIFYING_STARTED',
  WITNESS_VERIFYING_FAILED = 'WITNESS_VERIFYING_FAILED',
  WITNESS_VERIFIED = 'WITNESS_VERIFIED',
  REGISTERING_STARTED = 'REGISTERING_STARTED',
  REGISTERING_FAILED = 'REGISTERING_FAILED',
  REGISTERED = 'REGISTERED',
  MINTING_STARTED = 'MINTING_STARTED',
  MINTING_FAILED = 'MINTING_FAILED',
  MINTED = 'MINTED',
  REFERENCE_VDTS_STARTED = 'REFERENCE_VDTS_STARTED',
  REFERENCE_VDTS_FAILED = 'REFERENCE_VDTS_FAILED',
  REFERENCE_VDTS_COMPLETED = 'REFERENCE_VDTS_COMPLETED',
  CONFIRMED = 'CONFIRMED',
}
